import { createI18n } from 'vue-i18n';
import currencies from './currencies.json';
import i18nConfig from './config';
// import config from '@/config';

// vue3-migration-todo -- ElementLocale убрали, локаль меняется в Config Provider
// import ElementLocale from 'element-plus/lib/locale';

export const defaultLanguage = 'en';

// const _config = config || { enabledLanguages: [defaultLanguage] };

window.export_translations = () => {
  const text = JSON.stringify(i18nConfig, null, 4);
  const element = document.createElement('a');
  element.setAttribute(
    'href',
    `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`,
  );
  element.setAttribute('download', 'translations.json.json');
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

const i18n = createI18n({
  ...i18nConfig,
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  legacy: false,
  warnHtmlMessage: false,
  globalInjection: true,
  runtimeOnly: false,
});

export function i18nSetup(app, config) {
  // const _languages = config.enabledLanguages.map(l => ({ code: l, ...languages[l] }));
  if (app.hasOwnProperty('config') && app.config.hasOwnProperty('globalProperties')) {
    app.config.globalProperties.$languages = config.enabledLanguages;
    app.config.globalProperties.$currencies = currencies;

    Object.defineProperty(app.config.globalProperties, '$locale', {
      get() {
        return i18n.global.locale;
      },
      set(locale) {
        i18n.global.locale = locale;
      },
    });
  } else {
    app.prototype.$languages = _languages;
    app.prototype.$currencies = currencies;
    Object.defineProperty(app.prototype, '$locale', {
      get() {
        return i18n.locale;
      },
      set(locale) {
        i18n.locale = locale;
      },
    });
  }

  app.use(i18n);
}

export default i18n;
